module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-copyright element-without-heading",
    attrs: {
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("Copyright © 2019 by Genevieve Iseult Eldredge")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Rights held by Firefly Hill Press, LLC")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other noncommercial uses permitted by copyright law. For permission requests, write to the publisher, Subject Line: \"Attention: Permissions Coordinator,\" at company's email address below.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("Firefly Hill Press, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("4387 W. Swamp Rd #565")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("Doylestown, PA 18902")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "http://www.fireflyhillpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.fireflyhillpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "mailto:info@fireflyhillpress.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("info@fireflyhillpress.com")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("Print ISBN: 9781945495199")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("E-Book ISBN: 9781945723490")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0